module.exports = __webpack_public_path__ + "static/media/scoli-shoulder-2f.db0baa97.png";